import { render } from "./EditTaskDescriptionModal.vue?vue&type=template&id=52f8ca7a&scoped=true"
import script from "./EditTaskDescriptionModal.vue?vue&type=script&lang=js"
export * from "./EditTaskDescriptionModal.vue?vue&type=script&lang=js"

import "./EditTaskDescriptionModal.vue?vue&type=style&index=0&id=52f8ca7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f8ca7a"]])

export default __exports__